export default "__VITE_ASSET__DMnO5EpZ__"